import { DataStrategyFunction, DataStrategyResult } from "react-router";
import { onlyMessagesParamsChanged } from "common/helpers/MessagesUrl";

export const ROOT_ROUTE_ID = "root";

let lastNavigationUrl: string | null = null;
let panelOnlyUrl: string | null = null;

/** Exported for tests — the previous URL is module state that would otherwise leak between cases. */
export const resetNavigationHistory = (): void => {
  lastNavigationUrl = null;
  panelOnlyUrl = null;
};

export const isPanelOnlyNavigation = (url: string): boolean => url === panelOnlyUrl;

/**
 * React Router revalidates every matched loader when the search string changes.
 *
 * @param args
 * @returns
 */
export const panelAwareDataStrategy: DataStrategyFunction = async ({ matches, request, fetcherKey }) => {
  const previousUrl = lastNavigationUrl;
  const navigating = fetcherKey === null && request.method === "GET";

  if (navigating) lastNavigationUrl = request.url;

  const panelOnly =
    navigating && previousUrl !== null && onlyMessagesParamsChanged(new URL(previousUrl), new URL(request.url));

  panelOnlyUrl = panelOnly ? request.url : null;

  const results: Record<string, DataStrategyResult> = {};

  await Promise.all(
    matches.map(async (match) => {
      if (!match.shouldCallHandler()) return;
      if (panelOnly && match.route.id !== ROOT_ROUTE_ID) return;

      results[match.route.id] = await match.resolve();
    }),
  );

  return results;
};
